/**
 * description:
 * dateTime: 2024/8/20-下午5:51
 * author: ZhangJun 1580043700@qq.com
 */
import {SFuncModal} from "shj-components";
import {Form, Input, InputNumber, Select} from "antd";
import {useEffect} from "react";
import {useRequest, useSetState} from "ahooks";
import {queryMemberEventList} from "@/services/member.ts";

type EditOption = {
    title?: string,
    data?: any
    submit: (values: any) => Promise<any>
    destroy: (success: boolean) =>void
}

export function openEdit(option: EditOption) {
    const destroy = (success) => {
        option.destroy(success);
        modal.destroy();
    }
    const modal = SFuncModal({
        content: (<EditContent destroy={destroy} submit={option.submit} title={option.title} data={option.data}/>),
        title: option.title + '补发',
        vanish: true,
    });
}

function EditContent(props) {

    const [form] = Form.useForm();
    const [state, setState] = useSetState({loading: false});
    const {data: memberEventList}: any = useRequest(queryMemberEventList, {defaultParams: [{state: true}]});

    useEffect(() => {
        form.resetFields();
        form.setFieldsValue(props.data);
    }, [props.data])

    const onOk = () => {
        form.validateFields().then(values => {
            setState({loading: true})
            props.submit({
                ...props.data,
                ...values,
                memberEventName: (memberEventList || []).find(item => item?.id === values?.memberEventId)?.title
            }).then(() => {
                props.destroy(true);
                setState({loading: false})
            }).catch(() => {
                setState({loading: false})
            })
        })
    }

    return (
        <SFuncModal.Content onOk={onOk} onCancel={()=>props.destroy(false)} confirmLoading={state.loading}>
            <Form form={form} layout='vertical'>
                <Form.Item label='事件库' name='eventType' rules={[{required: true}]}>
                    <Select options={memberEventList || []} fieldNames={{label: 'title', value: 'type'}}></Select>
                </Form.Item>
                <Form.Item label={`发放${props.title}`} name='value' rules={[{required: true}]}>
                    <InputNumber min={1} precision={0} style={{width: '100%'}}/>
                </Form.Item>
                <Form.Item label='备注' name='description'>
                    <Input.TextArea maxLength={100}/>
                </Form.Item>
            </Form>
        </SFuncModal.Content>
    )
}

